import {
    MEETING_INSIGHTS_ROUTE,
    MY_DAY_ROUTE,
    NOTES_PANE_ROUTE,
    ORG_EXPLORER_ROUTE,
    ROOM_PANEL_ROUTE,
    LOCATION_CARD_ROUTE,
    CREATE_GROUP_ROUTE,
    ADD_MEMBERS_ROUTE,
    EDIT_GROUP_ROUTE,
    DISCOVER_GROUP_ROUTE,
    INBOX_RULES_ROUTE,
    DOWNLOAD_MOBILE_ROUTE,
    DATA_PROVIDER_ROUTE,
    ACTIVITY_FEED_ROUTE,
    YAMMER_ROUTE,
    YAMMER_PUBLISHER_ROUTE,
    CALENDAR_WIDGET_ROUTE,
    TODO_WIDGET_ROUTE,
    LEAVE_GROUP_ROUTE,
} from './routeNames';
import type { OpxRoute, OpxDeeplinkRoute } from './routeNames';

/**
 * View names for modern OPX app entry point
 *
 * Names must be identical/matching to the keys registered in OWS' OPX config service
 */
export type OpxViewNames =
    | 'MyDay'
    | 'RoomPanel'
    | 'OrgExplorer'
    | 'MeetingInsights'
    | 'NotesPane'
    | 'CalendarWidget'
    | 'TodoWidget'
    | 'LocationCard'
    | 'CreateGroup'
    | 'AddMembers'
    | 'EditGroup'
    | 'DiscoverGroup'
    | 'Yammer'
    | 'YammerPublisher'
    | 'DownloadMobile'
    | 'LeaveGroup'
    | 'ActivityFeed'
    | 'InboxRules'
    | 'DataProvider';

/**
 * View names for legacy OPX deeplink entry point, which is slated for deprecation in the near future
 *
 * Names must be identical/matching to the keys registered in OWS' OPX config service
 *
 * IMPORTANT: All new OPX component views should be registered under modern OPX app entry point *ONLY*
 */
export type OpxDeeplinkViewNames =
    | 'MyDay'
    | 'RoomPanel'
    | 'MeetingInsights'
    | 'LocationCard'
    | 'CreateGroup'
    | 'AddMembers'
    | 'EditGroup'
    | 'DiscoverGroup'
    | 'InboxRules'
    | 'DownloadMobile'
    | 'DataProvider'
    | 'ActivityFeed'
    | 'OrgExplorer'
    | 'Yammer'
    | 'CalendarWidget'
    | 'TodoWidget';

type RouteToViewDefinitionsOpx = { [route in OpxRoute]: OpxViewNames };

/**
 * Route -> view-name mappings for modern OPX app entry point
 */
export const ROUTE_TO_VIEW_DEFINITIONS_OPX: RouteToViewDefinitionsOpx = {
    [MY_DAY_ROUTE]: 'MyDay',
    [ROOM_PANEL_ROUTE]: 'RoomPanel',
    [ORG_EXPLORER_ROUTE]: 'OrgExplorer',
    [MEETING_INSIGHTS_ROUTE]: 'MeetingInsights',
    [NOTES_PANE_ROUTE]: 'NotesPane',
    [CALENDAR_WIDGET_ROUTE]: 'CalendarWidget',
    [YAMMER_ROUTE]: 'Yammer',
    [YAMMER_PUBLISHER_ROUTE]: 'YammerPublisher',
    [TODO_WIDGET_ROUTE]: 'TodoWidget',
    [LOCATION_CARD_ROUTE]: 'LocationCard',
    [CREATE_GROUP_ROUTE]: 'CreateGroup',
    [ADD_MEMBERS_ROUTE]: 'AddMembers',
    [EDIT_GROUP_ROUTE]: 'EditGroup',
    [DISCOVER_GROUP_ROUTE]: 'DiscoverGroup',
    [LEAVE_GROUP_ROUTE]: 'LeaveGroup',
    [DOWNLOAD_MOBILE_ROUTE]: 'DownloadMobile',
    [ACTIVITY_FEED_ROUTE]: 'ActivityFeed',
    [INBOX_RULES_ROUTE]: 'InboxRules',
    [DATA_PROVIDER_ROUTE]: 'DataProvider',
};

type RouteToViewDefinitionsOpxDeeplink = { [route in OpxDeeplinkRoute]: OpxDeeplinkViewNames };

/**
 * Route -> view-name mappings for legacy OPX deeplink entry point, which is slated for deprecation in the near future
 *
 * IMPORTANT: All new OPX mappings should be registered under modern OPX app entry point *ONLY*
 */
export const ROUTE_TO_VIEW_DEFINITIONS_OPXDEEPLINK: RouteToViewDefinitionsOpxDeeplink = {
    [MY_DAY_ROUTE]: 'MyDay',
    [ROOM_PANEL_ROUTE]: 'RoomPanel',
    [MEETING_INSIGHTS_ROUTE]: 'MeetingInsights',
    [LOCATION_CARD_ROUTE]: 'LocationCard',
    [CREATE_GROUP_ROUTE]: 'CreateGroup',
    [ADD_MEMBERS_ROUTE]: 'AddMembers',
    [EDIT_GROUP_ROUTE]: 'EditGroup',
    [DISCOVER_GROUP_ROUTE]: 'DiscoverGroup',
    [INBOX_RULES_ROUTE]: 'InboxRules',
    [DOWNLOAD_MOBILE_ROUTE]: 'DownloadMobile',
    [DATA_PROVIDER_ROUTE]: 'DataProvider',
    [ACTIVITY_FEED_ROUTE]: 'ActivityFeed',
    [ORG_EXPLORER_ROUTE]: 'OrgExplorer',
    [YAMMER_ROUTE]: 'Yammer',
    [CALENDAR_WIDGET_ROUTE]: 'CalendarWidget',
    [TODO_WIDGET_ROUTE]: 'TodoWidget',
};
